// extracted by mini-css-extract-plugin
module.exports = {"message":"Location_message__gtZ5g","btn-container":"Location_btn-container__35jKs"};